import { FaceWomanIcon } from './FaceWomanIcon';

/**
 * author: Michael Irigoyen
 * id C591017E-E3D0-48CA-A517-86B21DE853A0
 * name face-woman
 * version: 4.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/face-woman.svg
 * tags
 * - People / Family 
 */
export const EmojiWomanIcon = FaceWomanIcon;
export default EmojiWomanIcon